import type { WebSession } from "./domain";

export const anonymousSession: WebSession = { state: "ANONYMOUS", access: [] };

export async function loadSession(appId: string): Promise<WebSession> {
  const response = await fetch(`/web/api/v1/apps/${encodeURIComponent(appId)}/session`, {
    credentials: "same-origin",
    headers: { Accept: "application/json", "Cache-Control": "no-store" },
  });
  if (response.status === 401 || response.status === 404 || response.status === 503) return anonymousSession;
  if (!response.ok) throw new Error("web_session_unavailable");
  return response.json() as Promise<WebSession>;
}

export function beginGoogleLogin(appId: string): void {
  window.location.assign(`/web/api/v1/apps/${encodeURIComponent(appId)}/auth/google/start`);
}

export async function logout(appId: string): Promise<void> {
  const response = await fetch(`/web/api/v1/apps/${encodeURIComponent(appId)}/logout`, {
    method: "POST",
    credentials: "same-origin",
    headers: { "X-Requested-With": "appforge-public-web" },
  });
  if (!response.ok && response.status !== 204) throw new Error("web_logout_unavailable");
}
